import styled from '@emotion/styled';
import Link from 'client/components/Link';

export const StyledNavLink = styled(Link)<{
  isActive?: boolean;
  fontSize?: number;
}>`
  position: relative;
  display: inline-flex;
  align-items: center;
  color: ${({ isActive }) => (isActive ? '#fff' : 'rgba(255, 255, 255, 0.8)')};
  font-weight: bold;
  font-size: ${({ fontSize }) => fontSize || 16}px;

  &:hover,
  &:active:focus,
  &:focus,
  &:active {
    color: #fff;
    text-decoration: none;
  }

  @media (max-width: 968px) {
    font-size: 16px;
  }
`;
